import { ReactNode } from 'react';

export const NOTIFICATION_VARIANT_ERROR = 'error';
export const NOTIFICATION_VARIANT_INFO = 'info';
export const NOTIFICATION_VARIANT_SUCCESS = 'success';
export const NOTIFICATION_VARIANT_WARNING = 'warning';

export type NotificationVariant =
  | typeof NOTIFICATION_VARIANT_ERROR
  | typeof NOTIFICATION_VARIANT_INFO
  | typeof NOTIFICATION_VARIANT_SUCCESS
  | typeof NOTIFICATION_VARIANT_WARNING;

export interface Props {
  id: string;
  title: string;
  text?: string;
  lifetime: number;
  type?: NotificationVariant;
  disableTimeOut?: boolean;
  neutralBg?: boolean;
  onRemove?: (id: string) => void;
  /**
   * Optional inline content rendered below the text — checkbox, button,
   * link, etc. The Notification stays a layout primitive; callers compose
   * whatever interaction makes sense for their use case.
   */
  children?: ReactNode;
}
